import styled from 'styled-components'

function picForDate(date: Date): number {
  const isMorning = date.getHours() < 12
  const bucket = isMorning ? 'AM' : 'PM'

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  // LOCAL date + time bucket
  const key = `${year}-${month}-${day}-${bucket}`

  let hash = 0
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0
  }

  return (hash % 162) + 1
}

const date = new Date()
const pic = picForDate(date)

export const ImageMode = (props: { blurVal: number }) => {
  return (
    <>
      <Overlay />
      <ImgWrapper blurVal={props.blurVal} src={`pics/${pic}.jpg`} />
    </>
  )
}

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 20;
`

const ImgWrapper = styled.img<{
  blurVal: number
}>`
  display: flex;
  width: 100%;
  max-width: 620px;
  max-height: 100%;
  object-fit: contain;
  -webkit-filter: ${({ blurVal }) => `blur(${blurVal}px)`};
  -moz-filter: ${({ blurVal }) => `blur(${blurVal}px)`};
  -o-filter: ${({ blurVal }) => `blur(${blurVal}px)`};
  -ms-filter: ${({ blurVal }) => `blur(${blurVal}px)`};
  filter: ${({ blurVal }) => `blur(${blurVal}px)`};
`
